import { render } from "./AdviseRules.vue?vue&type=template&id=267d9022&scoped=true"
import script from "./AdviseRules.vue?vue&type=script&lang=js"
export * from "./AdviseRules.vue?vue&type=script&lang=js"

import "./AdviseRules.vue?vue&type=style&index=0&id=267d9022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267d9022"]])

export default __exports__